/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line




  var closeAnnouncement = document.querySelector('.js-announcement-bar-close');
  closeAnnouncement.addEventListener('click', function() {
    var announcementContainer = document.querySelector('.announcement-bar-static');
    var header = document.querySelector('.shopify-section-header');
    announcementContainer.classList.add('hidden');
    header.classList.add('top');
    localStorage.setItem("announcement", "true");
  })

  window.addEventListener('load', function() {
    if(localStorage.getItem("announcement") === "true") {
      var announcementContainer = document.querySelector('.announcement-bar-static');
      var header = document.querySelector('.shopify-section-header');
      announcementContainer.classList.add('hidden');
      header.classList.add('top');
    }
  })
  if (document.querySelector('.js-announcement-bar-close').length > 0 ) {
  }


  var buttons = document.querySelectorAll(".full-read-btn");
  buttons.forEach(function (button) {
    button.addEventListener("click", function () {
      var closestContent = findClosest(this, ".image-with-text__content");
      if (closestContent) {
        closestContent.classList.toggle("full");
      }
    });
  });

  function findClosest(element, selector) {
    while (element && !element.matches(selector)) {
      element = element.parentElement;
    }
    return element;
  }

  function checkIfElementExists(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  // Example usage
  let elementExists = checkIfElementExists("popup__close");

  if (elementExists) {
    var pressPopupLinks = document.querySelectorAll(".press__link");
    var pressPopup = document.getElementById("popup--press");
    var pressPopupClose = pressPopup.querySelector(".popup__close");

    pressPopupLinks.forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        let text = link.dataset.text,
            name = link.dataset.name,
            imageUrl = link.dataset.image,
            popupFullTextElement = pressPopup.querySelector(".popup__full_text"),
            popupNameElement = pressPopup.querySelector(".popup__name");
        popupImageElement = pressPopup.querySelector(".popup__image img");

        popupFullTextElement.innerHTML = text;
        popupNameElement.textContent = name;
        popupImageElement.src = imageUrl;

        pressPopup.classList.toggle("popup--visible");
      });
    });

    pressPopupClose.addEventListener("click", function (e) {
      pressPopup.classList.toggle("popup--visible");
    });
  }

  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }

  window.addEventListener('load', function() {
    if(document.querySelector('.slider-wrapper') !== null) {

      var activeSlide = document.querySelector('.slider-wrapper .slide-item.active');
      var activeSlideColor = activeSlide.getAttribute('data-color');

      var testimonialButton = document.querySelectorAll('.slide-item img');
      var testimonialItem = document.querySelectorAll('.slide-item');
      var testimonialClose = document.querySelector('.js-testimonial-close');

      testimonialItem.forEach(function(item) {
        let id = item.getAttribute('data-id');
        let src = "https://www.youtube.com/embed/" + id;



        let popup = document.querySelector('.js-popup');

        item.addEventListener('click', function () {
          popup.classList.add('active');
          document.querySelector('.popup__inner iframe').setAttribute('src', src);


          document.body.classList.add('nav-active')
        })
      })

      testimonialClose.addEventListener('click', function() {
        document.querySelector('.js-popup').classList.remove('active');
        document.body.classList.remove('nav-active')
        document.querySelector('.popup__inner iframe').setAttribute('src', '');
      })

    }
  })

  if(document.querySelector('.yt-slider') !== null) {
    var swiper = new Swiper(".yt-slider", {
      spaceBetween: 10,
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        576: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 5,
        },
      },
    });
  }

  if(document.querySelector('.swatch__button') !== null) {
    let productColor = document.querySelectorAll('.swatch__button');
    productColor.forEach(function(item) {
      item.addEventListener('click', function() {
        let productColorParent = item.closest('.product-grid-item__swatch');
        let productColorItems = productColorParent.querySelectorAll('.swatch__button');
        productColorItems.forEach(function(e) {
          e.classList.remove('active');
        })
        item.classList.add('active');
      })
    })
  }

  document.addEventListener('theme:cart:added', function(event) {
    const cartCounter = document.querySelectorAll('[data-cartcount]');
    if(cartCounter && window.cart && window.cart.cartCount){
      cartCounter.forEach((item)=>{
        item.dataset.cartcount = window.cart.cartCount;
      })
    }
  });

  document.addEventListener('theme:variant:change', function(event) {
    let varId = event.detail.variant.id;
    let URL = window.location.origin + window.location.pathname + "?variant=" + varId;
    fetch(URL)
        .then(response => response.text())  // Fetch the full HTML of the page
        .then(html => {
          // Create a virtual DOM to parse the HTML
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          if (doc.querySelector('.physical-store-available').getAttribute('data-phy') == 'true') {
            document.querySelector('.physical-store-available').style.display='block';
            document.querySelector('.product__submit__holder').style.display='none';
            document.querySelector('.selector-wrapper--qty').style.display='none';
          } else {
            document.querySelector('.physical-store-available').style.display='none'
            document.querySelector('.product__submit__holder').style.display='block';
            document.querySelector('.selector-wrapper--qty').style.display='block';
          }

          // if (doc.querySelector('.longer-shipping-time').getAttribute('data-long') == 'true') {
          //   document.querySelector('.longer-shipping-time').style.display='block';
          // } else {
          //   document.querySelector('.longer-shipping-time').style.display='none'
          // }
          // Use querySelector to get the specific element
          const element = doc.querySelector('#Block--9927e90d-2ecb-4104-af67-0dadf75b2a0a .product__accordion > div');
          // Log the HTML content of the element
          document.querySelector('#Block--9927e90d-2ecb-4104-af67-0dadf75b2a0a .product__accordion > div').innerHTML = element.innerHTML;
        })
        .catch(error => {
          console.error('Error fetching the page:', error);
        });
  });

  window.addEventListener('load', function() {
    if(document.querySelector('.prefooter') !== null) {
      var prefooter = document.querySelector('.prefooter');
      var prefooterImage = prefooter.querySelector('.banner-image__image-container .lazy-image:last-child');
      var prefooterTextContainer = prefooter.querySelector('.banner-image__text-container .banner-image__text-wrapper');
      prefooterTextContainer.appendChild(prefooterImage);
    }
  })


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


// ============================================================
// Pagination filter/sort persistence
// Preserves active filters and sort order when navigating pages
// ============================================================
// ============================================================
// Pagination filter/sort persistence
// Preserves active filters and sort order when navigating pages
// Uses event delegation — immune to DOM re-renders by filter apps
// ============================================================
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('#pagination a');
    if (!link) return;

    var currentParams = new URLSearchParams(window.location.search);
    currentParams.delete('page');
    if (!currentParams.toString()) return;

    e.preventDefault();
    var pageNum = new URLSearchParams(link.search).get('page');
    var newParams = new URLSearchParams(currentParams.toString());
    if (pageNum) newParams.set('page', pageNum);
    window.location.href = link.pathname + '?' + newParams.toString();
  }, true);
})();